import { Component } from '@angular/core';

@Component({
  selector: 'mpp-header-no-nav',
  templateUrl: './header-no-nav.component.html',
  styleUrls: ['./header-no-nav.component.scss'],
  standalone: false,
})
export class HeaderNoNavComponent {}
